<template>
  <details class="simple" open>
    <summary>Tabla de Pronóstico Comercial</summary>

    <div class="mb-2 mt-3" style="max-width: 300px">
      <b-form-input v-model="filter" type="search" placeholder="Búsqueda rápida"></b-form-input>
    </div>

    <b-table
      :items="items"
      :fields="fields"
      :filter="filter"
      striped
      hover
      responsive
      show-empty
      empty-text="No hay datos disponibles"
      foot-clone
      foot-variant="dark"
    >
      <!-- Footer con el resumen -->
      <template #foot(modulo)>
        <strong>{{ totalFilas }} Filas</strong>
      </template>

      <template #foot(recuento)>
        <span class="item-resumen">{{ totalRecuento }}</span>
      </template>

      <template #foot(recuentoGanadas)>
        <span class="item-resumen">{{ totalRecuentoGanadas }}</span>
      </template>

      <template #foot(ultimaVenta)>
        <span class="item-resumen">{{ ultimaVentaGlobal }}</span>
      </template>
    </b-table>
  </details>
</template>

<script>
import * as fmt from "@/utils/fmt.js";

export default {
  name: "TablaAnalisisComercial",

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    totalFilas() {
      return this.items.length;
    },
    totalRecuento() {
      return this.items.reduce((sum, item) => sum + item.recuento, 0);
    },
    totalRecuentoGanadas() {
      return this.items.reduce((sum, item) => sum + item.recuentoGanadas, 0);
    },
    ultimaVentaGlobal() {
      if (this.items.length === 0) return null;
      const ultimaVenta = this.items.reduce((latest, item) => {
        const itemDate = new Date(item.ultimaVenta);
        return itemDate > new Date(latest) ? item.ultimaVenta : latest;
      }, this.items[0].ultimaVenta);

      return fmt.date(ultimaVenta);
    },
  },

  data() {
    return {
      filter: "",
      fields: [
        {
          key: "modulo",
          label: "Módulo",
          sortable: true,
        },
        {
          key: "recuento",
          label: "Recuento",
          sortable: true,
          class: "text-center",
        },
        {
          key: "recuentoGanadas",
          label: "Recuento Ganadas",
          sortable: true,
          class: "text-center",
        },
        {
          key: "arrSegunPlanEuros",
          label: "ARR Según Tarifa",
          sortable: true,
          class: "text-right",
          formatter: fmt.euro,
        },
        {
          key: "arrMedioVentaEuros",
          label: "ARR Medio Venta",
          sortable: true,
          class: "text-right",
          formatter: fmt.euro,
        },
        {
          key: "ultimaVenta",
          label: "Ultima venta",
          sortable: true,
          class: "text-right",
          formatter: fmt.date,
        },
      ],
    };
  },

  methods: {
    getProductividadVariant(productividad) {
      if (productividad >= 10) return "success";
      if (productividad >= 5) return "warning";
      return "danger";
    },
  },
};
</script>

<style scoped>
.tabla-analisis-comercial {
  margin-top: 1rem;
}
.item-resumen {
  font-weight: bold;
}
</style>
